module.exports = __webpack_public_path__ + "img/lu.77f7c813.jpg";